export const MachineTypes = ["Machine", "Roulette", "ATM"];
